<div class="container-fluid pl-0 pr-0">
   <div class="row w-100 h-100 ">
      <div class="col-md-8 pl-0 pr-0">
         <div class="row  main-container ">
            <div class="main-content h-100 w-100">

               <!-- <a class="navbar-brand imagealter" href="#">
                  <img src="../../assets/images/logo-M (1).png"
                     alt="logo" class="ml-5 w-25">
               </a> -->

               <div class="col-md-10 mx-auto my-auto">
                  <p class="font-weight-bold font-size-18 text-left mt-5 ml-5 pt-5">Portfolio Management Suite</p>
                  <!-- <h2 class="font-weight-bold text-left ml-5 font-size-26">ADMINISTERED BY HEALTHCARE PROFESSIONALS</h2> -->
                  <!-- <br /> -->
                  <!-- <p class="text-justify mt-3 ml-5 font-size-14">  <i class="fa fa-arrow-down mt-4"></i> </p> -->

               </div>
            </div>
         </div>
      </div>
      <div class="col-md-4">
         <!--Nested rows within a column-->
         <div class="row p-3">
            <div class="col-12">
               <div class="row no-gutters">
                  <div class="myform form">
                     <p style="color: red;">{{version}}</p>
                     <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <h4 class="font-weight-bold font-size-18">Sign in</h4>
                        <!-- <h6 class="font-size-10">Or <span class="light-blue" (click)="navigateToSignup()" style="cursor: pointer">Create an account</span></h6> -->
                        <div class="form-group">
                           <input type="text" placeholder="Email" formControlName="email"
                              class="form-control font-size-12"
                              [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                           <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                              <div *ngIf="f.email.errors.required" class="font-size-12">Email is required</div>
                              <div *ngIf="f.email.errors.email" class="font-size-12">Email must be a valid email address
                              </div>
                           </div>
                        </div>
                        <div class="form-group">
                           <input type="password" placeholder="Password" formControlName="password"
                              class="form-control font-size-12"
                              [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                           <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                              <div *ngIf="f.password.errors.required" class="font-size-12">Password is required</div>
                              <div *ngIf="f.password.errors.minlength" class="font-size-12">Password must be at least 6
                                 characters</div>
                           </div>
                        </div>
                        <p class="small mt-3 text-justify font-size-11">This page is protected by
                           reCAPTCHA,and subject to the Google <span class="light-blue">Privacy Policy</span> and <span
                              class="light-blue">Terms of service</span>
                        </p>
                        <div class="text-center ">
                           <button type="submit" class=" btn btn-block btn btn-primary tx-tfm font-size-14">Sign
                              in</button>
                        </div>
                        <p class="small mt-3 light-blue font-size-10 font-weight-bold float-left"
                           style="cursor: pointer;" (click)="forgotPasswordDailog()">Forgot your password ?
                        </p>
                     </form>
                  </div>
               </div>
            </div>
         </div>

      </div>

      <p-dialog header="Forgot Password" [(visible)]="showForgotPasswordDialog" [closable]="false" [modal]="true"
         [style]="{ 'width': '40vw'}">
         <form [formGroup]="forgotPasswordForm" class="forgot-password-form" (ngSubmit)="onMailSubmit()">
            <div class="form-group">
               <label for="email">Email:</label>
               <input type="email" id="email" formControlName="email" placeholder="Enter your email"
                  class="form-control">
               <div *ngIf="emailsubmitted && fpass.email.errors && fpass.email.touched" class="error-message">
                  <div *ngIf="fpass.email.errors?.required">Email is required</div>
                  <div *ngIf="fpass.email.errors?.email">Invalid email format</div>
               </div>
            </div>
            <div class="button-group">
               <button type="submit" class="btn btn-primary">Submit</button>
               <button type="button" class="btn btn-secondary" (click)="onMailCancel()">Cancel</button>
            </div>
         </form>
      </p-dialog>
   </div>
</div>